import { useQuery } from "@tanstack/react-query";
import { financeApi } from "../../../finance-api-client";
import { queryKeys } from "../../query-keys";

export function usePayments(clubId: string | null) {
	return useQuery({
		queryKey: queryKeys.clubPortal.payments(clubId ?? ""),
		queryFn: () => financeApi.payments.list(clubId!),
		enabled: !!clubId,
	});
}

export function usePaymentDashboard(clubId: string | null) {
	return useQuery({
		queryKey: queryKeys.clubPortal.paymentDashboard(clubId ?? ""),
		queryFn: () => financeApi.payments.dashboard(clubId!),
		enabled: !!clubId,
	});
}
